<div class="wrapper" [ngClass]="getClass()">
    {{getMessage()}}
</div>